import news1Header from "./news/1/круглый-стол-2048x1365.jpg";
import news2Header from "./news/2/встреча-1.jpg";
import news3Header from "./news/3/Собрание-ННС.jpg";
import news4Header from "./news/4/7.jpg";
import news4_1 from "./news/4/8.jpg";
import news4_2 from "./news/4/9-768x1024.jpg";
import news5Header from "./news/5/данныеъ.jpg";
import news5_1 from "./news/5/видос-1.mp4";
import news6Header from "./news/6/3.jpg";
import news6_1 from "./news/6/1-1024x768.jpg";
import news6_2 from "./news/6/2.jpg";
import news6_3 from "./news/6/3 (1).jpg";
import news6_4 from "./news/6/4.jpg";
import news6_5 from "./news/6/5.jpg";
import news6_6 from "./news/6/6-768x1024.jpg";
import news7Header from "./news/7/DSC08968-2048x1365.jpg";
import news7_1 from "./news/7/DSC09008-1024x683.jpg";
import news8_1 from "./news/8/image_2025-05-21_20-21-28-576x1024.png";
import news8_2 from "./news/8/image_2025-05-21_20-21-44-575x1024.png";
import news9Header from "./news/9/photo_5393451464975841457_w.jpg";



export const newsData = [
  {
    id: 9,
    title: "Выступление команды AQUAGUARD на презентации интеллектуального решения для мониторинга водных ресурсов",
    headerImage: news9Header,
    date: "2025-10-09",
    excerpt: "В рамках проекта BR24993128 команда AQUAGUARD представила интеллектуальное решение для выявления нелегального использования водных ресурсов с использованием методов искусственного интеллекта и аэрокосмических снимков",
    content: [
      {
        type: "text",
        data: "В рамках проекта BR24993128 «Разработка информационно-аналитической системы для эффективного использования трансграничных водных ресурсов в сельскохозяйственном секторе Жамбылской области» состоялось выступление команды AQUAGUARD, в ходе которого было представлено интеллектуальное решение для выявления нелегального использования водных ресурсов с использованием методов искусственного интеллекта и аэрокосмических снимков."
      },
      {
        type: "text",
        data: "Система обеспечивает мониторинг водных объектов, оперативное обнаружение несанкционированного водозабора и помогает рационально распределять водные ресурсы, что напрямую способствует усилению водной и продовольственной безопасности региона.\n"
      },
      {
        type: "text",
        data: "Выступление команды вызвало активный интерес у представителей государственных органов, научного сообщества и бизнеса. Особенно отметили актуальность и практическую значимость проекта члены жюри конкурса AI SANA Generative Nation, в состав которого вошли:\n"
      },
      {
        type: "text",
        data: "Екатерина Смышляева, депутат Мажилиса Парламента РК;\n"
      },
      {
        type: "text",
        data: "Берик Ахметов, руководитель управления цифровизации и государственных услуг города Астаны;\n"
      },
      {
        type: "text",
        data: "Алибек Датбаев, Technology Leader компании Booking.com;\n"
      },
      {
        type: "text",
        data: "Гульмира Шарбакова, менеджер по архитектуре цифровых решений TengizChevroil;\n"
      },
      {
        type: "text",
        data: "Арай Бекембаев, Country Business Manager inDrive;\n"
      },
      {
        type: "text",
        data: "Айдана Каскырбек, генеральный директор Blockchain & AI Technology Center;\n"
      },
      {
        type: "text",
        data: "Адина Магавина, генеральный директор Alem.ai Foundation \n" +
            "Astana Hub\n"
      },
      {
        type: "text",
        data: "Жюри высоко оценило потенциал масштабирования проекта AQUAGUARD и его вклад в устойчивое развитие региональных водных систем."
      },
      {
        type: "text",
        data: ""
      },
    ]
  },
  {
    id: 8,
    title: "Установка датчиков и электронного оборудования в Жамбылской области",
    headerImage: null, // Используем placeholder
    date: "2025-05-20",
    excerpt: "На днях в одном из каналов региона была произведена установка специализированных датчиков и электронного оборудования для мониторинга водных ресурсов",
    content: [
      {
        type: "text",
        data: "На днях в одном из каналов региона была произведена установка:"
      },
      {
        type: "text",
        data: "• специализированных датчиков уровня и потока воды;"
      },
      {
        type: "text",
        data: "• электронного модуля в защитном ящике, включающего контроллер, блок связи а так же блок питания для автономной работы;"
      },
      {
        type: "text",
        data: "• соединительных элементов и источников питания, адаптированных под местные климатические и эксплуатационные условия."
      },
      {
        type: "image",
        data: news8_1,
      },
      {
        type: "image",
        data: news8_2,
      },
    ]
  },
  {
    id: 7,
    title: "Круглый стол по цифровизации водоучета в Жамбылском регионе прошёл на базе Astana IT University",
    headerImage: news7Header, 
    date: "2025-05-20",
    excerpt: "19 мая 2025 года на базе Astana IT University состоялся круглый стол на тему «Цифровизация водоучета Жамбылского региона в современных условиях на естественных протоках, водоемах и гидротехнических сооружениях»",
    content: [
      {
        type: "text",
        data: "19 мая 2025 года на базе Astana IT University состоялся круглый стол на тему «Цифровизация водоучета Жамбылского региона в современных условиях на естественных протоках, водоемах и гидротехнических сооружениях»"
      },
      {
        type: "text",
        data: "Цель мероприятия — подведение промежуточных итогов проделанной работы, обмен опытом между заинтересованными сторонами и определение ключевых направлений дальнейшего развития проекта."
      },
      {
        type: "text",
        data: "В работе круглого стола приняли участие представители:"
      },
      {
        type: "text",
        data: "• РГП «Казводхоз», включая Бакбергенова А. — начальника отдела диспетчеризации, энергетики и автоматизации Жамбылского филиала"
      },
      {
        type: "text",
        data: "• Цифрового департамента «Казсушар», представленного ведущим экспертом Ж. Абдибаевым"
      },
      {
        type: "text",
        data: "• Министерства водных ресурсов и ирригации Республики Казахстана"
      },
      {
        type: "text",
        data: "• ведущих IT-компаний, занимающихся разработкой решений в области цифровизации водного хозяйства"
      },
      {
        type: "text",
        data: "• представители научного сообщества, преподаватели и исследователи Astana IT University"
      },
      {
        type: "text",
        data: "Участники обсудили современные вызовы в области учёта водных ресурсов на трансграничных водоёмах и каналах, вопросы автоматизации и мониторинга, внедрение IoT-технологий и информационно-аналитических платформ. Особое внимание было уделено практике сбора и обработки данных в условиях сельскохозяйственного водопользования."
      },
      {
        type: "text",
        data: "Также прозвучали доклады о текущих результатах проекта: были представлены прототипы систем мониторинга, аналитические панели и перспективы масштабирования решений на другие регионы страны."
      },
      {
        type: "text",
        data: "Astana IT University выражает благодарность всем участникам круглого стола за активное участие и конструктивный диалог. Совместная работа учёных, ИТ-специалистов и представителей водного сектора открывает новые горизонты для цифровой трансформации водного хозяйства Казахстана."
      },
      {
        type: "image",
        data: news7_1,
      },
    ]
  },
  {
    id: 1,
    title: "Начало научного проекта: изучаем водные экосистемы",
    headerImage: news1Header,
    date: "2024-11-03",
    excerpt: "",
    content: [
      {
        type: "text",
        data: "Рады сообщить о старте нового научного проекта, направленного на исследование состояния и экологии рек! В рамках этого проекта уже проведен первый круглый стол, который состоялся в Международном Таразском Инновационном Институте им. Ш. Муртазы. На встрече собралась команда экспертов, включая зарубежных специалистов и представителей компаний, занимающихся разработкой систем экологического мониторинга и средств автоматизации. Обсуждались ключевые задачи и планы работ, нацеленные на создание современных подходов к сохранению и улучшению состояния водных ресурсов. Обмен опытом с международными коллегами и представителями ведущих компаний в области эко мониторинга позволяет нам использовать передовые технологии и методики в нашем проекте."
      },
      {
        type: "text",
        data: "На этой неделе наша команда также провела выездное обследование рек Жамбылского региона, включив в исследование несколько ключевых водоемов, представляющих интерес с точки зрения экологии и состояния их экосистем. Особое внимание было уделено проблемам трансграничных вод, которые требуют комплексного подхода и сотрудничества с соседними странами. Это важный этап для более глубокого понимания состояния водных экосистем и факторов, влияющих на их состояние."
      },
      {
        type: "text",
        data: "Будем делиться с вами новостями и достижениями на каждом этапе нашего пути! Поддержите нас и следите за обновлениями, чтобы узнать больше о наших открытиях и рекомендациях."
      },
    ]
  },
  {
    id: 2,
    title: "Проведена встреча с министерством водных ресурсов и ирригации",
    headerImage: news2Header,
    date: "2024-12-09",
    excerpt: "",
  },
  {
    id: 3,
    title: "Доклад на ННС",
    headerImage: news3Header,
    date: "2024-12-18",
    excerpt: "",
    content: [
      {
        type: "text",
        data: "18 декабря 2024 года на заседании Национального научного совета был рассмотрен промежуточный отчет по выполнению научно-исследовательской работы в рамках программно-целевого финансирования, а также результаты экспертизы ГНТЭ по промежуточному отчету. Коллеги поблагодарили за четкий и достаточно развернутый ответ. Такой интерес и ответственный подход со стороны ННС радует."
      },
    ]
  },
  {
    id: 4,
    title: "Проведена встреча с Жамбыльским филиалом РГП Казводхоз",
    headerImage: news4Header,
    date: "2025-01-13",
    excerpt: "Было обсуждено согласование установки оборудования на гидропостах ГМК и Жасоркен",
    content: [
      {
        type: "image",
        data: news4_1,
      },
      {
        type: "image",
        data: news4_2,
      },
    ]
  },
  {
    id: 5,
    title: "Было произведено подключение датчиков для измерения потоков к блоку управления",
    headerImage: news5Header,
    date: "2025-03-30",
    excerpt: "",
    content: [
      {
        type: "video",
        data: news5_1,
      },
    ]
  },
  {
    id: 6,
    title: "Обследование объектов для установки научно-исследовательского оборудования",
    headerImage: news6Header,
    date: "2025-04-02",
    excerpt: "С 26 по 28 марта 2025 года в г. Кордай и вблизи населенного пункта Благовещенка (Жамбылская область) было осуществлено обследование двух объектов для установки научно-исследовательского оборудования для проведения замеров в рамках цифровизации водоучета воды на открытом канале на реке Чу и Георгиевском магистральном канале. Результатом стало согласование места установки оборудования и перечня подготовительных работ.",
    content: [
      {
        type: "image",
        data: news6_1,
      },
      {
        type: "image",
        data: news6_2,
      },
      {
        type: "image",
        data: news6_3,
      },
      {
        type: "image",
        data: news6_4,
      },
      {
        type: "image",
        data: news6_5,
      },
      {
        type: "image",
        data: news6_6,
      },
    ]
  },
  // {
  //   id: 1,
  //   title: "Запуск нового проекта мониторинга качества воды",
  //   headerImage: null,
  //   date: "2024-01-15",
  //   excerpt: "Наша команда объявляет о запуске инновационного проекта по мониторингу качества воды в регионе.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "Сегодня мы рады объявить о запуске нашего нового проекта по мониторингу качества воды. Этот проект направлен на улучшение контроля за состоянием водных ресурсов в нашем регионе."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/water-monitoring-station.jpg",
  //       caption: "Современная станция мониторинга качества воды"
  //     },
  //     {
  //       type: "text",
  //       data: "Система включает в себя автоматизированные датчики, которые будут отслеживать различные параметры качества воды в режиме реального времени. Данные будут доступны для анализа через наш веб-интерфейс."
  //     },
  //     {
  //       type: "video",
  //       data: "/videos/project-overview.mp4",
  //       caption: "Обзор проекта мониторинга воды"
  //     }
  //   ]
  // },
  // {
  //   id: 2,
  //   title: "Новые технологии в анализе качества воды",
  //   headerImage: "/images/water-analysis.jpg",
  //   date: "2024-01-20",
  //   excerpt: "Внедрение современных методов анализа позволяет получать более точные данные о состоянии водных ресурсов.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "Наша лаборатория внедрила новейшие технологии анализа качества воды. Использование спектрометрии и хроматографии позволяет определять даже минимальные концентрации загрязняющих веществ."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/laboratory-equipment.jpg",
  //       caption: "Современное лабораторное оборудование"
  //     },
  //     {
  //       type: "text",
  //       data: "Эти технологии помогают нам предоставлять более точные и надежные результаты анализа, что критически важно для обеспечения безопасности питьевой воды."
  //     }
  //   ]
  // },
  // {
  //   id: 3,
  //   title: "Результаты исследования за первый квартал",
  //   headerImage: "/images/research-results.jpg",
  //   date: "2024-02-01",
  //   excerpt: "Представляем результаты комплексного исследования качества воды за первый квартал 2024 года.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "По итогам первого квартала 2024 года наша команда провела комплексное исследование качества воды в 15 точках мониторинга."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/research-chart.jpg",
  //       caption: "График изменения показателей качества воды"
  //     },
  //     {
  //       type: "text",
  //       data: "Результаты показывают стабильное соответствие большинства показателей установленным нормам. Однако выявлены несколько точек, требующих дополнительного внимания."
  //     },
  //     {
  //       type: "video",
  //       data: "/videos/quarterly-report.mp4",
  //       caption: "Видеоотчет о результатах исследования"
  //     },
  //     {
  //       type: "text",
  //       data: "Детальные данные доступны в разделе мониторинга нашего сайта. Мы продолжаем работу по улучшению качества водных ресурсов."
  //     }
  //   ]
  // },
  // {
  //   id: 4,
  //   title: "Партнерство с международными организациями",
  //   headerImage: "/images/partnership.jpg",
  //   date: "2024-02-10",
  //   excerpt: "Заключено соглашение о сотрудничестве с ведущими международными организациями в области экологии.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "Мы рады объявить о заключении стратегического партнерства с несколькими международными организациями, занимающимися вопросами экологии и качества воды."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/signing-ceremony.jpg",
  //       caption: "Церемония подписания соглашения о партнерстве"
  //     },
  //     {
  //       type: "text",
  //       data: "Это партнерство откроет новые возможности для обмена опытом, технологиями и лучшими практиками в области мониторинга качества воды."
  //     }
  //   ]
  // },
  // {
  //   id: 5,
  //   title: "Обучение местных специалистов",
  //   headerImage: "/images/training.jpg",
  //   date: "2024-02-15",
  //   excerpt: "Программа обучения местных специалистов по работе с системами мониторинга качества воды.",
  //   content: [
  //     {
  //       type: "text",
  //       data: "Запущена комплексная программа обучения местных специалистов работе с современными системами мониторинга качества воды."
  //     },
  //     {
  //       type: "video",
  //       data: "/videos/training-program.mp4",
  //       caption: "Процесс обучения специалистов"
  //     },
  //     {
  //       type: "text",
  //       data: "Программа включает теоретические занятия и практические тренинги по использованию оборудования и интерпретации данных."
  //     },
  //     {
  //       type: "image",
  //       data: "/images/training-session.jpg",
  //       caption: "Практическое занятие с оборудованием"
  //     }
  //   ]
  // }
]; 